import React from 'react'
import selectn from 'selectn'
import { ScoreCell, InningsSummary, TopStories, Commentary, Squad, ScorecardSummary, Innings, MatchOfficials, MatchDetails } from './lite/index'

/**
 * Generate the Game package view for Cricket
 * @param  {String} options.pageType PageType
 * @param  {Object} options.state    Application state
 * @return {Object}                  Arrays having React components for each column
 */
export const getCricketViewLite  = ({
  pageType = 'game',
  state = {},
  params
}) => {
  let appView = ''
  let currentPageLink = '#'
  const links = state.links || []

  links.map((link) => {
    if(link.pageType === pageType) {
      currentPageLink = link.href
    }
  })

  switch(pageType) {
    case 'game':
    case 'match':
      appView = getSummary({ state, params, currentPageLink })
      break

    case 'scorecard':
      appView = getScorecard({ state })
      break
  }

  return appView
}

const getSummary = ({ state, params, currentPageLink }) => {
  const isLimitedOvers = selectn('matchFlags.limitedOvers', state)
  const partCommentary = state.partCommentary || {}
  const { gameStateClassFeature, summary, gameStrip, showGameDetailFooter } = state
  const { sport } = params

  let content = [
    <ScoreCell key="sc" {...gameStrip} sport={sport} className={gameStateClassFeature} summaryText={summary} showGameDetailFooter={showGameDetailFooter} />,
    <TopStories key="t" {...state.article} />,
    <Commentary key="c" {...partCommentary} isWebView={state.isWebView} showCommentPreText={true}/>,
    <Squad key="s" {...state.rosters} />
  ]

  switch(state.gameState) {
    case 'live':
      content = [
        <ScoreCell key="sc" {...gameStrip} sport={sport} className={gameStateClassFeature} summaryText={summary} showGameDetailFooter={showGameDetailFooter} currentPageLink={currentPageLink} />,
        <InningsSummary key="i" {...state.innings} isSmallDevice={state.isSmallDevice} isWebView={state.isWebView} isLimitedOvers={isLimitedOvers}/>,
        <Commentary key="c" {...state.partCommentary} isWebView={state.isWebView}/>
      ]
      break

    case 'final':
      content = [
        <ScoreCell key="sc" {...gameStrip} sport={sport} className={gameStateClassFeature} summaryText={summary} showGameDetailFooter={showGameDetailFooter} />,
        <TopStories key="t" {...state.article} />,
        <ScorecardSummary key="ss" {...state.scorecardSummary} isLimitedOvers={isLimitedOvers} />,
        <MatchDetails key="md" {...state.matchDetails} hideShowClass={true} />,
        <Commentary key="c" {...state.partCommentary} isWebView={state.isWebView}/>
      ]
      break
  }

  return (
    <div key="sm" className="cricinfo__content">
      {content}
    </div>
  )
}

const getScorecard = ({ state }) => {
  const officials = selectn('matchDetails.officials', state)

  return (
    <div className="cricinfo__content">
      <Innings key="in" {...state.scorecard} isWebView={state.isWebView} />
      <MatchOfficials key="mo" officials={officials} />
    </div>
  )
}

export default getCricketViewLite



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/getAppViewLite.js
 **/